import * as yup from 'yup';

import {
  fieldStateYupValidation,
} from '@/shared/utils/validationSchema';

export const ordenTrabajoCorporativoFormSchema = yup.object({
  numero_referencia: yup
    .string()
    .required('El campo numero referencia es requerido')
    .max(200, 'El campo numero referencia no debe exceder los 200 caracteres'),

  pppoe: yup
    .string()
    .required('El campo pppoe es requerido')
    .max(200, 'El campo pppoe no debe exceder los 200 caracteres'),
  pppassword: yup
    .string()
    .required('El campo pppassword es requerido')
    .max(200, 'El campo pppassword no debe exceder los 200 caracteres'),
  puerto: yup
    .string()
    .required('El campo puerto es requerido')
    .max(200, 'El campo puerto no debe exceder los 200 caracteres'),
  ipv4_actual: yup
    .string()
    .required('El campo ipv 4 actual es requerido')
    .max(200, 'El campo ipv 4 actual no debe exceder los 200 caracteres'),
  es_router_ac: yup
    .boolean()
    .typeError('El campo es router ac es requerido')
    .required('El campo es router ac es requerido'),
  serie_ont: yup
    .string()
    .required('El campo serie ont es requerido')
    .max(200, 'El campo serie ont no debe exceder los 200 caracteres'),
  hora_inicio: yup
    .string()
    .required('El campo hora inicio es requerido')
    .max(200, 'El campo hora inicio no debe exceder los 200 caracteres'),
  hora_fin: yup
    .string()
    .required('El campo hora fin es requerido')
    .max(200, 'El campo hora fin no debe exceder los 200 caracteres'),

  nap: yup.string().optional().nullable(),
  nodo: yup.string().optional().nullable(),
  olt: yup.string().optional().nullable(),
  router: yup.string().optional().nullable(),

  estado: fieldStateYupValidation,

  codigo: yup
    .string()
    .required('El campo codigo es requerido')
    .max(200, 'El campo codigo no debe exceder los 200 caracteres'),
  flota: yup.string().optional().nullable(),
});

// shape
export const ordenTrabajoSubeTecnicoFormSchema = ordenTrabajoCorporativoFormSchema.shape({
  codigo_bobina: yup
    .string()
    .required('El campo codigo bobina es requerido')
    .max(200, 'El campo codigo bobina no debe exceder los 200 caracteres'),
  splitter: yup
    .string()
    .required('El campo splitter es requerido')
    .max(200, 'El campo splitter no debe exceder los 200 caracteres'),
  manga: yup
    .string()
    .required('El campo manga es requerido')
    .max(200, 'El campo manga no debe exceder los 200 caracteres'),
  color_hilo: yup
    .string()
    .required('El campo color hilo es requerido')
    .max(200, 'El campo color hilo no debe exceder los 200 caracteres'),
  num_hilo: yup
    .string()
    .required('El campo num hilo es requerido')
    .max(200, 'El campo num hilo no debe exceder los 200 caracteres'),

  test_5g: yup
    .string()
    .required('El campo test 5g es requerido')
    .max(200, 'El campo test 5g no debe exceder los 200 caracteres'),
  potencia_dbm: yup
    .string()
    .required('El campo potencia dbm es requerido')
    .max(200, 'El campo potencia dbm no debe exceder los 200 caracteres'),
  potencia_ont: yup
    .string()
    .required('El campo potencia ont es requerido')
    .max(200, 'El campo potencia ont no debe exceder los 200 caracteres'),
  es_conexion_tierra: yup
    .boolean()
    .typeError('El campo es conexion tierra es requerido')
    .required('El campo es conexion tierra es requerido'),
  es_regulador: yup
    .boolean()
    .typeError('El campo es regulador es requerido')
    .required('El campo es regulador es requerido'),
  ubicacion_equipo_ac: yup
    .string()
    .required('El campo ubicacion equipo ac es requerido')
    .max(
      200,
      'El campo ubicacion equipo ac no debe exceder los 200 caracteres'
    ),
  ubicacion_ont: yup
    .string()
    .required('El campo ubicacion ont es requerido')
    .max(200, 'El campo ubicacion ont no debe exceder los 200 caracteres'),
  metraje_exedente: yup
    .string()
    .required('El campo metraje exedente es requerido')
    .max(200, 'El campo metraje exedente no debe exceder los 200 caracteres'),
  metraje_utilizado: yup
    .string()
    .required('El campo metraje utilizado es requerido')
    .max(200, 'El campo metraje utilizado no debe exceder los 200 caracteres'),



});
